module.exports = __webpack_public_path__ + "static/OSS_Dev_Flow-331d625c2b86a096c3ad33c4992d1fff.pdf";